function nonBlank(it) {
  return it != null && (typeof it != "string" || it.length > 0);
}

export default function clinicAddress(clinic) {
  return (
    typeof clinic == "object" &&
    [
      [
        [clinic.logradouro, clinic.numero && "nº " + clinic.numero]
          .filter(nonBlank)
          .join(" "),
        clinic.bairro
      ]
        .filter(nonBlank)
        .join(", "),
      [clinic.cidade, clinic.estado].filter(nonBlank).join("-")
    ]
      .filter(nonBlank)
      .join(" - ")
  );
}
